<perfect-scrollbar
  class="side-nav"
  sideNav
  [ngClass]="isFolded == true ? 'w-80' : 'w-280'"
>
  <!-- Skeleton Loader -->
  @if (loader) {
  <div class="sn-loader">
    @for (i of [0,1,2,3,4,5,6,7,8,9]; track i) {
    <nz-space nzSize="middle" class="sn-loader-item">
      <nz-space-item>
        <nz-skeleton-element
          class="m-r-10"
          nzType="avatar"
          [nzActive]="true"
          [nzSize]="'small'"
          [nzShape]="'square'"
        ></nz-skeleton-element>
      </nz-space-item>
      <nz-space-item>
        <nz-skeleton-element
          nzType="input"
          [nzActive]="true"
          [nzSize]="'small'"
          style="width: 120px"
        ></nz-skeleton-element>
      </nz-space-item>
    </nz-space>
    }
  </div>
  }

  <!-- Menu Content -->
  <div class="sn-wrapper">
    <div class="sn-menu-area">
      <ul
        class="ant-menu ant-menu-root ant-menu-inline sn-menu"
        [ngClass]="{
          'ant-menu-inline-collapsed': isFolded,
          'ant-menu-dark': isSideNavDark
        }"
      >
        @for (item of menuItems; track item) {
        <li
          [ngClass]="{
            'ant-menu-submenu': item.children.length > 0,
            'ant-menu-submenu-inline': item.children.length > 0,
            'ant-menu-item': item.children.length === 0,
            'sn-group-label': item.hdr_in == 1,
            'ant-menu-submenu-open': isMenuExpanded(item)
          }"
          [routerLinkActive]="
            item.children.length > 0 ? '' : 'ant-menu-item-selected'
          "
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <!-- Parent with children -->
          @if (item.children.length > 0) {
          <a
            role="button"
            tabindex="0"
            class="ant-menu-submenu-title sn-parent-link"
            (click)="toggleMenu(item)"
          >
            <span class="sn-icon-wrap">
              <i nz-icon [nzType]="item.prnt_mnu_icn_tx" nzTheme="outline"></i>
            </span>
            @if (!isFolded) {
            <span class="sn-label" title="{{ item.prnt_mnu_itm_nm }}">{{
              item.prnt_mnu_itm_nm
            }}</span>
            }
            <i class="ant-menu-submenu-arrow"></i>
          </a>
          }
          <!-- Leaf item -->
          @if (item.children.length === 0 && item.hdr_in == 0) {
          <a [routerLink]="item.mnu_itm_url_tx" class="sn-leaf-link">
            <span class="sn-icon-wrap">
              <i nz-icon [nzType]="item.mnu_itm_icn_tx" nzTheme="outline"></i>
            </span>
            @if (!isFolded) {
            <span class="sn-label" title="{{ item.mnu_itm_nm }}">{{
              item.mnu_itm_nm
            }}</span>
            }
          </a>
          }
          <!-- Group header -->
          @if (item.hdr_in == 1) {
          <div class="sn-group-text" title="{{ item.mnu_itm_nm }}">
            {{ item.mnu_itm_nm }}
          </div>
          }
          <!-- Submenu (Level 2) -->
          @if (item.children.length > 0 && isMenuExpanded(item)) {
          <ul
            class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu sn-submenu"
          >
            @for (subItem of item.children; track subItem) {
            <li
              [ngClass]="{
                'ant-menu-submenu': subItem.submenu.length > 0,
                'ant-menu-submenu-inline': subItem.submenu.length > 0,
                'ant-menu-item': subItem.submenu.length === 0,
                'ant-menu-submenu-open': subItem.isExpanded
              }"
              [routerLinkActive]="
                subItem.submenu.length > 0 ? '' : 'ant-menu-item-selected'
              "
            >
              @if (subItem.submenu.length > 0) {
              <a
                role="button"
                tabindex="0"
                class="ant-menu-submenu-title sn-child-link"
                (click)="toggleSubMenu(item, subItem)"
              >
                <i
                  nz-icon
                  [nzType]="subItem.mnu_itm_icn_tx"
                  class="sn-child-icon"
                ></i>
                <span class="sn-child-label" title="{{ subItem.mnu_itm_nm }}">{{
                  subItem.mnu_itm_nm
                }}</span>
                <i class="ant-menu-submenu-arrow"></i>
              </a>
              } @if (subItem.submenu.length === 0) {
              <a [routerLink]="subItem.mnu_itm_url_tx" class="sn-child-link">
                <i
                  nz-icon
                  [nzType]="subItem.mnu_itm_icn_tx"
                  class="sn-child-icon"
                ></i>
                <span class="sn-child-label" title="{{ subItem.mnu_itm_nm }}">{{
                  subItem.mnu_itm_nm
                }}</span>
              </a>
              }
              <!-- Third Level -->
              @if (subItem.submenu.length > 0 && subItem.isExpanded) {
              <ul
                class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu sn-submenu"
              >
                @for (subItem of subItem.submenu; track subItem) {
                <li
                  [ngClass]="
                    subItem.submenu.length > 0
                      ? 'ant-menu-submenu ant-menu-submenu-inline ant-menu-submenu-open'
                      : 'ant-menu-item'
                  "
                  routerLinkActive="ant-menu-item-selected"
                >
                  @if (subItem.submenu.length > 0) {
                  <a class="ant-menu-submenu-title sn-child-link">
                    <i
                      nz-icon
                      [nzType]="subItem.prnt_mnu_icn_tx"
                      class="sn-child-icon"
                    ></i>
                    <span class="sn-child-label" title="{{ subItem.title }}">{{
                      subItem.title
                    }}</span>
                    <i class="ant-menu-submenu-arrow"></i>
                  </a>
                  } @if (subItem.submenu.length === 0) {
                  <a
                    [routerLink]="subItem.mnu_itm_url_tx"
                    class="sn-child-link"
                  >
                    <i
                      nz-icon
                      [nzType]="subItem.mnu_itm_icn_tx"
                      class="sn-child-icon"
                    ></i>
                    <span class="sn-child-label" title="{{ subItem.title }}">{{
                      subItem.title
                    }}</span>
                  </a>
                  }
                </li>
                }
              </ul>
              }
            </li>
            }
          </ul>
          }
        </li>
        }
      </ul>
    </div>

    <!-- Footer -->
    <div class="sn-footer">
      @if (!isFolded) {
      <div class="sn-version">Version 1.0</div>
      }
      <div class="sn-powered">
        <a href="">
          @if (!isFolded) {
          <p class="sn-powered-text">Powered &amp; Developed By</p>
          }
          <p class="sn-logo-wrap">
            @if (!isFolded) {
            <img
              src="assets/images/logo/D._logo1.png"
              alt="Logo"
              class="sn-logo"
            />
            } @if (isFolded) {
            <img
              src="assets/images/logo/dreamstep_D.png"
              alt="Logo"
              class="sn-logo-fold"
            />
            }
          </p>
        </a>
      </div>
    </div>
  </div>
</perfect-scrollbar>
